import { LineChart } from '@mui/x-charts';
import { FC } from 'react';
import dayjs from 'dayjs';
import { getCssVariable } from '../../../../utils';

interface PeakDipsGraphProps {
  className?: string;
  chartData: number[];
  height?: number;
}

const WEEK_INDICES = Array.from({ length: 7 }, (_, i) => i + 1);
const primaryColor = getCssVariable('--color-primary');
const grayColor = getCssVariable('--color-gray-base');

const PeakDipsGraph: FC<PeakDipsGraphProps> = ({ className = '', chartData, height = 200 }) => {
  return (
    <div className={className}>
      <LineChart
        xAxis={[
          {
            data: WEEK_INDICES,
            valueFormatter: (value) =>
              dayjs()
                .day(value - 1)
                .format('dd'),
            tickInterval: WEEK_INDICES,
          },
        ]}
        series={[
          {
            data: chartData,
            color: primaryColor,
            showMark: true,
            label: 'Peak Energy',
            valueFormatter: (value) => `${Math.round(value as number)}`,
          },
        ]}
        yAxis={[
          {
            min: 0,
            max: 100,
          },
        ]}
        slotProps={{
          legend: {
            hidden: true,
          },
        }}
        sx={{
          '& .MuiChartsAxis-tickLabel': {
            fill: grayColor,
          },
          '& .MuiChartsAxis-directionX .MuiChartsAxis-line': {
            stroke: grayColor,
          },
          '& .MuiChartsAxis-directionY .MuiChartsAxis-line': {
            stroke: grayColor,
          },
          '& .MuiChartsAxis-tick': {
            stroke: grayColor,
          },
        }}
        height={height}
      />
    </div>
  );
};

export default PeakDipsGraph;
